module.exports = __webpack_public_path__ + "img/tamper-triggered.e4c0917c.svg";